import React, { useCallback } from 'react';
import TimeRangeSelector from '../../TimeRangeSelector/TimeRangeSelector';

const TimeRangeComponent = ({ model, value, onChange }) => {
  const _onChange = useCallback(timeRange => {
    onChange(model, timeRange);
  }, [model, onChange]);

  return (<TimeRangeSelector
    key={model.path}
    value={value}
    onChange={_onChange} />
  );
};

export default TimeRangeComponent;
